import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../core/withGShoc';
import { computeComponentIcon, getResourceLabel, isRTL } from '../core/utils/utils';

class ComponentLink extends React.Component {

    render() {

        const { data, defaultLang, margin, iconColor } = this.props;
        const avatar = computeComponentIcon(data.type, {
            verticalAlign: 'bottom',
            marginInlineEnd: 4,
            color: iconColor
        });

        const title = getResourceLabel(data, "title", defaultLang, false);
        const rtl = isRTL(defaultLang);
        return (
            <div style={{ ...(rtl) && { textAlign: 'right' } }}>
                <Typography
                    data-test="component-link"
                    variant="caption"
                    dir={rtl ? "rtl" : null}
                    style={{
                        ...(margin) && { marginTop: 4 },
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>
                    {avatar}
                    {title}
                </Typography>
            </div>
        );
    }
}

ComponentLink.defaultProps = {
    margin: false,
    iconColor: '#808080'
};

ComponentLink.propTypes = {
    iconColor: PropTypes.string,
    margin: PropTypes.bool,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};

export default withGS(ComponentLink, ["ALL"], ["id", "title", "hasEntitlement", "type"], { predicates: ["http://purl.org/dc/terms/title"] });